export default {
    lang: {
        name: 'Owners'
    }
}